import BookmarkWorker from '../webworkers/main.worker.js';
import env from '../util/env';
import _ from 'lodash';
import {documentGetAllParamNames} from '../util/uiconstants.js';

const bookmark = (config) => (store) => (next) => (action) => {
	const __NAME = 'Bookmark Middleware',
		SET_TASK_BOOKMARK = 'SET_TASK_BOOKMARK';

	/**
	 * Action to skip this middleware and continue with next if it is not of type SET_TASK_BOOKMARK
	 * SET_TASK_BOOKMARK is called when user clicks OFFLINE button in the menu
	 * This middleware will not handle the POST call to set the bookmark status for task
	 * API-Middleware will make a post call to set the bookmark status
	 * This middleware is reponsible to download all the tasks and its associated data when user clicks on OFFLINE
	 * This will get all the other task metadata and documents on bookmark.
	 * This action will have the list of tasks in action.meta
	 */
	if (action.type != SET_TASK_BOOKMARK) {
		return next(action);
		//return Promise.resolve('Skkiping middleware since its get all task');
	}

	let data = action.meta.api.data;
	if (data && data.length && !data[0].value) {
		return next(action);
	}

	if (!config) {
		const configMsg = `
		Config unavailable.
		The AD package requires config to get the authorization token for the api call.`;
		console.log(configMsg);
	}

	// action will have array of taskid and url
	// get list of all task detail calls -> for now maintain it locally in this file
	// make web worker calls to get task details

	// action.meta is set to empty object before we populate it with details.
	if (!action.meta) {
		action.meta = {};
	}

	//Below are the list of API ursl that are user to get the data for offline
	//https://herculesapp-dev1-euw.cloudapp.eydev.net/api/Engagements/1565721
	//https://herculesapp-dev1-euw.cloudapp.eydev.net/api/Engagements/1565721/Tasks/c31ae056-b3e9-48b5-ac00-17317ff9fa80/Description
	//https://herculesapp-dev1-euw.cloudapp.eydev.net/api/Engagements/1565721/Tasks/c31ae056-b3e9-48b5-ac00-17317ff9fa80/Documents?ReturnOnlyRelatedDocuments=true&workspaceid=100006082&taskTypeId=25
	//https://herculesapp-dev1-euw.cloudapp.eydev.net/api/Engagements/1565721/Tasks/c31ae056-b3e9-48b5-ac00-17317ff9fa80/Components
	//https://herculesapp-dev1-euw.cloudapp.eydev.net/api/Engagements/1565721/Annotations?categoryId=0&statusId=0&expand=opennotescount&taskId=c31ae056-b3e9-48b5-ac00-17317ff9fa80
	//https://herculesapp-dev1-euw.cloudapp.eydev.net/api/Engagements/1565721/Annotations?categoryId=0&statusId=0&taskId=c31ae056-b3e9-48b5-ac00-17317ff9fa80
	//https://herculesapp-dev1-euw.cloudapp.eydev.net/api/Engagements/1565721/Users/
	//https://127.0.0.1:58001/api/v2/Document?docUrl=https://canvaseng-doc-dev1-euw.cloudapp.eydev.net/api/v2&engagementId=1565721&resourceUri=https://eygs.onmicrosoft.com/canvaseng-dev1-euw&fileId=a9f27145-dab4-4d5c-9d9a-c3b52fbf57f5&docTypeId=7&openDocument=false&readonly=false

	let url = [],
		_len = action.meta.tasks && action.meta.tasks.length;

	if (_len) {
		let cc = document.getElementById('communicationchannel');
		let clientDetails;
		if (_.isArray(store.getState().engagementMetaData)) {
			clientDetails = store.getState().engagementMetaData.find((item) => {
				return item.engagementid == store.getState().engagement.engagementId;
			});
		}
		let cc_data = Object.assign({}, store.getState().engagement, {
			incountryuri: env.getURL('eng_web'),
			clientid: clientDetails ? clientDetails.clientid : 0,
			clientname: clientDetails ? clientDetails.clientname : 'Invalid',
			herculesurl: env.getURL('hercules_web')
		});
		cc.contentWindow.postMessage(cc_data, env.getURL('Zeus_web'));
	}

	for (var i = 0; i < _len; i++) {
		let taskId = action.meta.tasks[i].taskId;
		url.push(
			...[
				action.meta.url + 'Tasks/' + taskId,
				action.meta.url + 'Tasks/' + taskId + '/Description',
				action.meta.url +
					'documents?' +
					documentGetAllParamNames.documentCategoryName +
					'=evidence&' +
					documentGetAllParamNames.filteredEntityType +
					'=task' +
					'&' +
					documentGetAllParamNames.filteredEntityIdGuid +
					'=' +
					taskId +
					'&orderBy=HasExecutiveReview&skipRefreshRenderFilters=true&pageSIze=-1&includeReviewNotes=true&includeApprovals=true' +
					'&includeFindings=true&includeClientApprovals=true&includeRelatedTasks=true&pageSize=-1&searchtype=contains',
				action.meta.url + 'Tasks/' + taskId + '/Components',
				action.meta.url + 'Annotations?categoryId=0&statusId=0&expand=opennotescount&taskId=' + taskId,
				action.meta.url + 'Annotations?categoryId=0&statusId=0&taskId=' + taskId
			]
		);
	}

	// To Do- move this to tasklist middle ware to dispatch web worker action
	url.push(action.meta.url + 'Users/Me');
	//https://herculesapp-dev1-euw.cloudapp.eydev.net/api/Engagements/1568585/tasks/?categoryId=2&currentPage=1&orderByAscending=true&pageSize=20&searchString=
	url.push(action.meta.url + 'tasks/?categoryId=2');

	// Adding worker meta to action so that all the task related calls are handled by web-workers
	action.meta.worker = BookmarkWorker;
	action.meta.workerParams = {
		url,
		token: action.meta.auth.token
	};

	return next(action);
};

export default bookmark;
